import { createAppTheme } from '@hwm/ui-lib';
import { styleConstants } from './constants';

export const theme = createAppTheme(styleConstants, {
  palette: {
    error: {
      main: styleConstants.colors.warningColor,
    },
    warning: {
      main: styleConstants.colors.warningColor,
    },
    secondary: {
      main: styleConstants.colors.secondaryColor,
    },
    common: {
      black: styleConstants.colors.common,
    },
  },
});

export default theme;
